import * as CR from '../services/countryRegions';
import { helpers } from '../utils';

export const ACTION_COUNTRY_REGIONS_LOAD_LIST = 'countryRegions/loadList';
export const ACTION_COUNTRY_REGIONS_LOAD_ITEM = 'countryRegions/loadItem';
export const ACTION_COUNTRY_REGIONS_CREATE = 'countryRegions/create';
export const ACTION_COUNTRY_REGIONS_UPDATE = 'countryRegions/update';
export const ACTION_COUNTRY_REGIONS_REMOVE = 'countryRegions/remove';

export default {
  namespace: 'countryRegions',

  state: null,

  effects: {
    * loadList({ payload }, { call }) {
      try {
        return yield call(CR.countryRegionsListRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadItem({ payload }, { call }) {
      try {
        return yield call(CR.countryRegionsItemRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * create({ payload }, { call }) {
      try {
        const { data } = payload;
        return yield call(CR.countryRegionsCreateRequest, data);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * update(
      {
        payload: { id, data },
      },
      { call },
    ) {
      try {
        yield call(CR.countryRegionsUpdateRequest, { id }, { ...data });
      } catch (e) {
        helpers.processException(e);
      }
    },

    * remove(
      {
        payload: { id },
      },
      { call },
    ) {
      try {
        return yield call(CR.countryRegionsRemoveRequest, {
          id,
        });
      } catch (e) {
        return e;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/countryRegions.js